const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	grades : [],
	current_grade : null,
}

const getters = {
	fetchGrades : (state) => state.grades,
	fetchCurrentGrade : (state) => state.current_grade,
}

const actions = {
	loadGrades({commit}, {token, filter}){
		const query_arr = []
		for(let key in filter){
			if(filter[key]){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
		return $http.get(`grade?${query_str}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_GRADES', response.data)
		})
	},

	loadGradeDetails({commit}, {grade, token}){
		return $http.get(`grade/${grade}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_GRADE', response.data)
		})
	},

	createGrade({commit}, {grade, token}){
		// let grade_formdata = new FormData()
		// for(let key in grade){
		// 	if(key == 'gradefiles'){
		// 		for(let i in grade[key]){
		// 			grade_formdata.append(`${key}`, grade[key][i])
		// 		}
		// 	}else{
		// 		grade_formdata.append(key, grade[key])
		// 	}	
		// }
		
		return $http.post('grade', grade, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('ADD_GRADE', response.data)
		})
	},

	updateGrade({commit}, {grade_id, grade, token}){
		// let grade_formdata = new FormData()
		// for(let key in grade){
		// 	if(key == 'gradefiles'){
		// 		for(let i in grade[key]){
		// 			grade_formdata.append(`${key}`, grade[key][i])
		// 		}
		// 	}else if(key == 'editfiles'){
		// 		grade_formdata.append(key, JSON.stringify(grade[key]))
		// 	}else{
		// 		grade_formdata.append(key, grade[key])
		// 	}	
		// }
		
		return $http.put(`grade/${grade_id}`, grade, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('UPDATE_GRADE', response.data)
		})
	},

	deleteGrade({commit}, {grade, token}){
		return $http.delete(`grade/${grade}`, {
			headers : {
				'x-auth-token' : token
			} 
		}).then(() => {
			commit('REMOVE_GRADE', grade)	
		})
	},
}

const mutations = {
	SET_GRADES : (state, grades) => {
		state.grades = grades
	},
	SET_CURRENT_GRADE : (state, grade) => {
		state.current_grade = grade
	},
	ADD_GRADE : (state, grade) => {
		state.grades.push(grade)
	},
	UPDATE_GRADE : (state, grade) => {
		state.current_grade = grade
	},
	REMOVE_GRADE : (state, grade_id) => {
		state.grades = state.grades.filter(grade => grade._id != grade_id)
	},
}

export default {
	state, getters, actions, mutations
}